
import {
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
  DASHBOARD_FAIL
} from '../../actions/Dashboard/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  totaL_ACTIVOS: number;
  total_ALTAS: number;
  total_BAJAS: number;
  total_BODEGA: number;
  total_REMATE: number;
  total_TRASLADOS: number;
  valor_INVENTARIO: number;
  totaL_EN_USO: number;
  porcentajE_EN_USO: number;
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  totaL_ACTIVOS: 0,
  total_ALTAS: 0,
  total_BAJAS: 0,
  total_BODEGA: 0,
  total_REMATE: 0,
  total_TRASLADOS: 0,
  valor_INVENTARIO: 0,
  totaL_EN_USO: 0,
  porcentajE_EN_USO: 0
};

// Reducer con tipos definidos
const kpisReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        totaL_ACTIVOS: action.payload.totaL_ACTIVOS,
        total_ALTAS: action.payload.totaL_ALTAS,
        total_BAJAS: action.payload.totaL_BAJAS,
        total_BODEGA: action.payload.totaL_BODEGA,
        total_REMATE: action.payload.totaL_REMATE,
        total_TRASLADOS: action.payload.totaL_TRASLADOS,
        valor_INVENTARIO: action.payload.valoR_INVENTARIO,
        totaL_EN_USO: action.payload.totaL_EN_USO,
        porcentajE_EN_USO: action.payload.porcentajE_EN_USO
      };
    case DASHBOARD_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};



export default kpisReducers;
